
import { accountProps } from "../Accounts/Accounts";
import blueWarningIcon from '../../../images/blue-warning-icon.svg';
import Modal from 'react-bootstrap/Modal';
import closeIcon from '../../../images/close-icon.svg';
import * as Styled from './DissconnectModalStyles';
import SubscriptionsStore from '../../xstores/subscriptions';

interface DisconnectModalProps {
  isOpen: boolean;
  onClose: any;
  service: accountProps | any;
}

const getAccountName = (sub:any) => {
  let account = sub.email;
  if (sub.platform === 'slack') {
    account = sub.team_id;
  }
  return account;
}

const DisconnectModal = ({ isOpen, onClose, service }: DisconnectModalProps) => {
  const handleDisconnect = () => {
    if (service.subs) {
      service.subs.forEach((sub: any) => {
        const account = getAccountName(sub);
        SubscriptionsStore.disconnectAccount({
          platform: sub.platform,
          account,
        })
      })
    } else {
      SubscriptionsStore.disconnectAccount({
        platform: service.platform,
        account: getAccountName(service),
      })
    }

    onClose();
  }

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      size='sm'
      contentClassName='custom-content'
      dialogClassName='custom-dialog'
    >
      <Styled.StyledModalBody >
        <Styled.StyledModalBtn onClick={onClose}
          className='HeaderBtn'
        >
          <Styled.StyledImg src={closeIcon} alt='Close' />
        </Styled.StyledModalBtn>
        <Styled.StyledParagraph>
          Are you sure you want to <br />
            disconnect the <br />
            account?
          </Styled.StyledParagraph>
        <Styled.Container>
          <img src={blueWarningIcon} alt="Warning" />
          <Styled.StyledSpan>
            All your data connected to this account will be removed.
            </Styled.StyledSpan>
        </Styled.Container>
      </Styled.StyledModalBody>
      <Styled.StyledModalFooter>
        <Styled.StyledModalBtn variant='outline-primary' onClick={handleDisconnect}
          className='DeleteStyle'
        >
          Disconnect
        </Styled.StyledModalBtn>
      </Styled.StyledModalFooter>
    </Modal>
  );
}

export default DisconnectModal;